import {createSlice} from '@reduxjs/toolkit';
import {httpGet, httpPost} from '../../util/Rest';
import {CHAPTER_FILED, STATE} from '../../constants/Lookup';

const initialData = {
  bankruptcyData: {},
  dropDownData: {},
  bankruptcyStatus: null,
  isLoading: false,
  errorMsg: null,
  successMsg: null,
};

const slice = createSlice({
  name: 'bankruptcyHistory',
  initialState: {
    ...initialData,
  },
  reducers: {
    fetchStart: (state) => {
      state.isLoading = true;
      state.errorMsg = null;
    },
    getBankruptcyData: (state, action) => {
      state.bankruptcyData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    fetchDropDownData: (state, action) => {
      state.dropDownData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    postBankruptcyData: (state, action) => {
      state.bankruptcyStatus = action.payload.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload.response;
    },
    fetchError: (state, action) => {
      state.errorMsg = action?.payload?.data?.error ? action.payload.data.error : action.payload;
      state.isLoading = false;
    },
    resetStatus: (state) => {
      state.bankruptcyStatus = null;
      state.errorMsg = null;
      state.successMsg = null;
      state.isLoading = false;
    },
  },
});

export default slice.reducer;

// Actions

const {
  getBankruptcyData,
  fetchDropDownData,
  postBankruptcyData,
  fetchStart,
  fetchError,
  resetStatus,
} = slice.actions;

export const fetchBankruptcy = (agencyTie) => {
  return (dispatch) => {
    dispatch(fetchStart());
    Promise.all([
      httpPost('lookup/find/all/lookup', {
        typeCode: [CHAPTER_FILED, STATE],
      }),
      httpGet(`bankruptycase/find/bankruptcycase/${agencyTie}`),
    ])
      .then((data) => {
        const lookUpApiData = data && data[0] ? data[0] : null;
        const bankruptcyData = data && data[1] ? data[1] : null;
        if (lookUpApiData && lookUpApiData.status && lookUpApiData.status === 200) {
          dispatch(fetchDropDownData(lookUpApiData.data));
        } else {
          dispatch(fetchError(lookUpApiData?.lookUpApiData?.error));
        }
        if (bankruptcyData && bankruptcyData.status && bankruptcyData.status === 200) {
          dispatch(getBankruptcyData(bankruptcyData.response));
        } else {
          dispatch(fetchError(bankruptcyData.message));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error && error.message ? error.message : ''));
      });
  };
};

export const postBankruptcy = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost('bankruptycase/save/bankruptcycase', details)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(postBankruptcyData(data));
        } else {
          dispatch(fetchError(data));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const resetStatusCode = () => {
  return (dispatch) => {
    dispatch(resetStatus());
  };
};
